import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Card, Spinner, Button, Table, Col, Row, Alert } from 'react-bootstrap';
import { FaEdit, FaTrash, FaPlus, FaArrowLeft } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
 import { getAllUser } from "./allUserActions";
 import { newUserDeletion } from "./userDeleteAction";
import $ from 'jquery';
import Swal from "sweetalert2";
import { getSRolePermission } from '../userRolePermission/rolepermissionAction';
    


const AllUser = () => {
    
    const [userid, setUserid] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const firstUpdate = useRef(true);
    const { users, isLoading }= useSelector((state) => state.allUsers);
     const { status, message} = useSelector((state) => state.userDelete);

    useEffect(() => {
        dispatch(getSRolePermission());
        
    }, []);

    const { permissionisLoading, combinedrolepermissiondetails } = useSelector(
        (state) => state.rolePermissionList
      );
      
      const filteredPermissions = combinedrolepermissiondetails.filter(
        (item) => item.label === "All Users"
      );
      
      let menu_add = 0;
      let menu_edit = 0;
      let menu_delete = 0;
      
      if (filteredPermissions.length > 0) {
        const permission = filteredPermissions[0];
        menu_add = permission.menu_add;
        menu_edit = permission.menu_edit;
        menu_delete = permission.menu_delete;
      }

   
    useLayoutEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            dispatch(getAllUser());
            return;
        }

        
    });
    useEffect(() => {
        dispatch(getAllUser());
       
    }, [dispatch,message]);

    const onUpdate = (id) => {
                navigate('/modifyUser/'+id);
            }

    if (isLoading) {
        return (
            <>
                <Container className="my-4 mx-4 container-xl justify-content-center">
                    <h2>Loading.....</h2>
                    {isLoading && <Spinner variant='info' center="true" animation='border' />}

                </Container>
            </>
        );
    }

    if (users.length === 0) {
        return (
            <>
                
                <div className="my-4 container-xl">
                    <div className="card" style={{marginTop:'-80px'}}>
                    <div class="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>All Users</h3>
                     
                    </div>
                        <div className="card-body">
                            <div>
                                <Link to="/">
                                    <span className="badge bg-success" style={{ backgroundColor: 'rgb(156 186 237)', color: 'white' }}>
                                        <FaArrowLeft />&nbsp;Go Back
                                    </span>
                                </Link>
                            </div>
                            <br />
                            <div>
                                <table className="table table-hover table-bordered display" style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Email Id</th>
                                            <th>Contact No</th>
                                            <th>User Role</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                        <td colSpan="5" style={{ textAlign: 'center' }}>No data available</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }



   

   // const orderedUsers = users.slice().sort((a, b) => b.id.localeCompare(a.id))

    const renderedUsers = users
    .filter((user) => user.user_role !== "super admin").map((user,index) => (
        <tr key={user.id}>
            <td>{index + 1}</td>
            {/* <td>{supplier.supplier_code}</td> */}
            <td>{user.username}</td>   
            <td>{user.email}</td>
            <td>{user.contactno}</td>
            <td>{user.user_role}</td>
            <td>{user.user_status === 1 ? <span className="badge bg-success"> enable</span> : <span className="badge bg-danger"> Disable</span>}</td>
            <td><>{menu_edit === 1 && ( <Button className="btn btn-sm btn-warning me-2"  onClick={() => onUpdate(user.id)} ><FaEdit className='fwcolor' /></Button>)}
            {menu_delete === 1 && (<Button className="btn btn-sm btn-danger me-2"  onClick={() => onDelete(user.id)} ><FaTrash className='fwcolor' /></Button>)}</></td>
        </tr>
    ))

    
    const onDelete = (id) => {
                Swal.fire({
                    title: 'Are you sure want to delete the user ?',
                    showDenyButton: true,
                    icon:'error',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    denyButtonText: 'No',
                    customClass: {
                      actions: 'my-actions',
                      cancelButton: 'order-1 right-gap',
                      confirmButton: 'order-2',
                      denyButton: 'order-3',
                    }
                  }).then((result) => {
                    if (result.isConfirmed) {
                        dispatch(newUserDeletion(id)).then(() => {
                            dispatch(getAllUser());
                          Swal.fire('User Deleted Successfully!', '', 'success');
                        })
                    }
                    
                     else if (result.isDenied) {
                      Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
                    }
                  })
                }



    //initialize datatable
    $(document).ready(function () {
        setTimeout(function () {
            if ($.fn.dataTable.isDataTable('#example')) {
                const table = $('#example').DataTable();
            }
            else {
                const table = $('#example').DataTable({
                    paging: true,
                    pagingType: 'full_numbers',
                    pageLength: 5,
                     processing: true,
                     dom: 'Bfrtip',
                    // buttons: ['copy', 'csv', 'print'],
                    buttons: ['csv', 'print'],
                    destroy: true,

                });
            }

        },
            1000
        );
    });
    return (
        <>

            <div className="my-4  container-xl">
                <div class="card" style={{marginTop:'-80px'}}>
                <div class="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>All Users</h3>
                     
                    </div>
                    <div class="card-body">
                        <div>
                        <Link to="/"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 

                        </div>
                        <br />

                        {users?.length
                            ? (
                                <table id="example" class="table table-hover table-bordered display" style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            {/*  <th>Supplier Code</th> */}
                                            <th>Name</th>
                                            <th>Email Id</th>
                                            <th>Contact No</th>
                                            <th>User Role</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderedUsers}


                                    </tbody>
                                </table>
                            ) : <p>No users to display</p>
                        }

                    </div>
                </div>
            </div>

        </>
    )
}
    

export default AllUser;
